module.exports = __webpack_public_path__ + "media/media/values/face-3-7406f5dee82a86af7052f09825861328.jpg";